import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  saveActionDeviceStateInfo,
  saveActionStateDescription,
  saveActionType,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectTimerValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/MezzoActions/TimersActions/SelectTimerValue/SelectTimerValue'
import SelectTimerValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/MezzoActions/TimersActions/SelectTimerValue/SelectTimerValue'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectTimerValueIOS) : withStyles(SelectTimerValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    isChangeActionStateMode,
    isEditActionMode,
    initialAction,
  } = state.scenes.currentSceneCreating
  const {
    actionDescription,
  } = state.scenes.currentSceneCreating.currentAction
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isChangeActionStateMode,
    isEditActionMode,
    actionDescription,
    isMobile,
    path,
    actions,
    initialAction,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionType,
  saveActionDeviceStateInfo,
  saveActionStateDescription,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectTimerValueEnhanced = enhance

export default withRouter(SelectTimerValueEnhanced)
